// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/admin";
const ROOTS_POS = "/pos";

const ROOTS_RIDER = "/rider";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  privacy: "/privacy-policy",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  notification: path(ROOTS_DASHBOARD, "/notification"),
  profile: path(ROOTS_DASHBOARD, "/profile"),
  rider_profile: path(ROOTS_RIDER, "/profile"),
  search: path(ROOTS_DASHBOARD, "/search"),
  pos: path(ROOTS_POS, "/"),
  stockHistories: path(ROOTS_DASHBOARD, "/stock-histories"),

  contents: {
    tags: {
      root: path(ROOTS_DASHBOARD, "/contents/tags"),
      list: path(ROOTS_DASHBOARD, "/contents/tags/list"),
      add: path(ROOTS_DASHBOARD, "/contents/tags/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/contents/tags/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/contents/tags/view/${id}`),
    },
    blogs: {
      root: path(ROOTS_DASHBOARD, "/contents/blogs"),
      list: path(ROOTS_DASHBOARD, "/contents/blogs/list"),
      add: path(ROOTS_DASHBOARD, "/contents/blogs/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/contents/blogs/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/contents/blogs/view/${id}`),
    },
    // new
    catering: {
      root: path(ROOTS_DASHBOARD, "/contents/caterings"),
      list: path(ROOTS_DASHBOARD, "/contents/caterings/list"),
      add: path(ROOTS_DASHBOARD, "/contents/caterings/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/contents/caterings/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/contents/caterings/view/${id}`),
      formData: path(ROOTS_DASHBOARD, "/contents/caterings/catering-form-data"),
    },
  },

  meta: {
    pages: {
      root: path(ROOTS_DASHBOARD, "/meta/pages"),
      list: path(ROOTS_DASHBOARD, "/meta/pages/list"),
      add: path(ROOTS_DASHBOARD, "/meta/pages/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/meta/pages/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/meta/pages/view/${id}`),
    },
    sitemap: {
      root: path(ROOTS_DASHBOARD, "/meta/sitemap"),
    },
  },

  notices: {
    root: path(ROOTS_DASHBOARD, "/notices"),
    list: path(ROOTS_DASHBOARD, "/notices/list"),
    add: path(ROOTS_DASHBOARD, "/notices/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/notices/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/notices/view/${id}`),
  },

  contacts: {
    root: path(ROOTS_DASHBOARD, "/contacts"),
    list: path(ROOTS_DASHBOARD, "/contacts/list"),
    add: path(ROOTS_DASHBOARD, "/contacts/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/contacts/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/contacts/view/${id}`),
  },

  manage: {
    root: path(ROOTS_DASHBOARD, "/manage"),
    faqs: {
      root: path(ROOTS_DASHBOARD, "/manage/faqs"),
      list: path(ROOTS_DASHBOARD, "/manage/faqs/list"),
      add: path(ROOTS_DASHBOARD, "/manage/faqs/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/manage/faqs/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/manage/faqs/view/${id}`),
    },
  },

  products: {
    root: path(ROOTS_DASHBOARD, "/products"),
    list: path(ROOTS_DASHBOARD, "/products/list"),
    orderableList: path(ROOTS_DASHBOARD, "/products/list?orderable=true"),
    nonOrderableList: path(ROOTS_DASHBOARD, "/products/list?orderable=false"),
    add: path(ROOTS_DASHBOARD, "/products/add"),
    addOrderable: path(ROOTS_DASHBOARD, "/products/add?orderable=true"),
    edit: (id) => path(ROOTS_DASHBOARD, `/products/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/products/view/${id}`),
  },

  orders: {
    root: path(ROOTS_DASHBOARD, "/orders"),
    list: path(ROOTS_DASHBOARD, "/orders/list"),
    calendar: path(ROOTS_DASHBOARD, "/orders/calendar"),
    add: path(ROOTS_DASHBOARD, "/orders/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/orders/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/orders/view/${id}`),
  },
  crmorder: {
    root: path(ROOTS_DASHBOARD, "/crmorder"),
    list: path(ROOTS_DASHBOARD, "/crmorder/list"),
    add: path(ROOTS_DASHBOARD, "/crmorder/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/crmorder/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/crmorder/view/${id}`),
  },
  crmorder_rider: {
    root: path(ROOTS_RIDER, "/crmorder"),
    list: path(ROOTS_RIDER, "/crmorder/list"),
    add: path(ROOTS_RIDER, "/crmorder/add"),
    edit: (id) => path(ROOTS_RIDER, `/crmorder/edit/${id}`),
    view: (id) => path(ROOTS_RIDER, `/crmorder/view/${id}`),
  },

  entries: {
    root: path(ROOTS_DASHBOARD, "/entries"),
    schools: {
      root: path(ROOTS_DASHBOARD, "/entries/schools"),
      list: path(ROOTS_DASHBOARD, "/entries/schools/list"),
      add: path(ROOTS_DASHBOARD, "/entries/schools/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/schools/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/schools/view/${id}`),
    },

    dresses: {
      root: path(ROOTS_DASHBOARD, "/entries/dresses"),
      list: path(ROOTS_DASHBOARD, "/entries/dresses/list"),
      add: path(ROOTS_DASHBOARD, "/entries/dresses/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/dresses/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/dresses/view/${id}`),
    },

    sizes: {
      root: path(ROOTS_DASHBOARD, "/entries/sizes"),
      list: path(ROOTS_DASHBOARD, "/entries/sizes/list"),
      add: path(ROOTS_DASHBOARD, "/entries/sizes/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/sizes/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/sizes/view/${id}`),
    },

    galleries: {
      root: path(ROOTS_DASHBOARD, "/entries/galleries"),
      list: path(ROOTS_DASHBOARD, "/entries/galleries/list"),
      add: path(ROOTS_DASHBOARD, "/entries/galleries/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/galleries/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/galleries/view/${id}`),
    },

    categories: {
      root: path(ROOTS_DASHBOARD, "/entries/categories"),
      list: path(ROOTS_DASHBOARD, "/entries/categories/list"),
      add: path(ROOTS_DASHBOARD, "/entries/categories/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/categories/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/categories/view/${id}`),
      assignPrinter: path(ROOTS_DASHBOARD, "/entries/categories/assign-printer"),
    },

    houses: {
      root: path(ROOTS_DASHBOARD, "/entries/houses"),
      list: path(ROOTS_DASHBOARD, "/entries/houses/list"),
      add: path(ROOTS_DASHBOARD, "/entries/houses/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/houses/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/houses/view/${id}`),
    },
  },
  users: {
    root: path(ROOTS_DASHBOARD, "/users"),
    list: path(ROOTS_DASHBOARD, "/users/list"),
    add: path(ROOTS_DASHBOARD, "/users/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/users/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/users/view/${id}`),
  },
  riders: {
    root: path(ROOTS_DASHBOARD, "/riders"),
    list: path(ROOTS_DASHBOARD, "/riders/list"),
    add: path(ROOTS_DASHBOARD, "/riders/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/riders/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/riders/view/${id}`),
  },
  promoCodes: {
    root: path(ROOTS_DASHBOARD, "/promo-codes"),
    list: path(ROOTS_DASHBOARD, "/promo-codes/list"),
    add: path(ROOTS_DASHBOARD, "/promo-codes/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/promo-codes/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/promo-codes/view/${id}`),
    usage: (id) => path(ROOTS_DASHBOARD, `/promo-codes/usage/${id}`),
  },
  activityLogs: path(ROOTS_DASHBOARD, "/activity-logs"),
  settings: path(ROOTS_DASHBOARD, "/settings"),
  cartModal: path(ROOTS_DASHBOARD, "/cart-modal"),
};
